var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{on:{"click":_vm.probarIris}},[_vm._v("Probar Iris")]),(_vm.respuesta)?_c('p',[_vm._v(_vm._s(_vm.respuesta))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }